import { useState } from 'react';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody, Table } from 'reactstrap';
import { SpringBootWrapper } from './SpringBoot.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import springboot1 from './../../../resources/content/springboot1.png';
import springboot2 from './../../../resources/content/springboot2.png';
import springboot3 from './../../../resources/content/springboot3.png';
import springboot4 from './../../../resources/content/springboot4.png';
import springboot5 from './../../../resources/content/springboot5.png';
import springboot6 from './../../../resources/content/springboot6.png';
import springboot7 from './../../../resources/content/springboot7.png';

function SpringBoot() {
   const [open, setOpen] = useState('');  // Track which accordion item is open

   // Function to toggle accordion item
   const toggle = (index: any) => {
      if (open === index) {
         setOpen('');  // Close the item if it's already open
      } else {
         setOpen(index);  // Open the new item
      }
   };

   return (
      <SpringBootWrapper>
         <header className="entry-header">
            <h1 className="entry-title" itemProp="headline">Spring Boot</h1>
         </header>
         <br />
         <Accordion open={open} toggle={toggle}>
            <AccordionItem>
               <AccordionHeader targetId="1">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Introduction</span>
               </AccordionHeader>
               <AccordionBody accordionId="1">
                  <p className="text-align-justify" >Spring Boot&nbsp;is an open-source Java-based framework that creates a micro Service. An architecture that allows the developers to develop and deploy services independently is known as Micro Service. To achieve the lightweight model to support business applications, each service running has its own process. Spring boot helps in building stand-alone and production-ready&nbsp;spring&nbsp;applications because it needs minimal Spring configuration.</p>
                  <ul className="text-align-justify" >
                     <li >It provides an easier and faster way to set up, configure, and run both simple and web-based applications.</li>
                     <li >The&nbsp;RAD (Rapid Application Development)&nbsp;feature is provided to the Spring Framework by a Spring module known as Spring Boot. </li>
                     <li >It is the combination of&nbsp;Spring Framework&nbsp;and&nbsp;Embedded Servers.</li>
                     <li >Spring boot doesn’t require any XML configuration (deployment descriptor). It uses convention over configuration software design paradigm that means it decreases the effort of the developer.</li>
                     <li >We can use Spring&nbsp;STS IDE&nbsp;or&nbsp;Spring Initializer&nbsp;to develop Spring Boot Java applications. In this tutorial, we will discuss using Spring Initializer.</li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="2">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Prerequisite</span>
               </AccordionHeader>
               <AccordionBody accordionId="2">
                  <ul className="text-align-justify" >
                     <li >Java 1.8</li>
                     <li >Maven 3.0+</li>
                     <li >Spring Framework 5.0.0.BUILD-SNAPSHOT</li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="3">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Features</span>
               </AccordionHeader>
               <AccordionBody accordionId="3">
                  <ol className="is-style-default text-align-justify" >
                     <li ><strong >Starter Project </strong>
                        <ul className="is-style-default" >
                           <li >It provides a quick starter project (start.spring.io) with auto-configuration(web, JPA, dev tools, etc).</li>
                        </ul>
                     </li>
                     <li ><strong >Web Development </strong>
                        <ul >
                           <li >We can easily create a self-contained HTTP application that uses embedded servers like&nbsp;Tomcat, Jetty,&nbsp;or Undertow. </li>
                           <li >We can use the&nbsp;spring-boot-starter-web&nbsp;module to start and run the application quickly.</li>
                        </ul>
                     </li>
                     <li ><strong >SpringApplication </strong>
                        <ul >
                           <li >The SpringApplication is a class that provides a convenient way to bootstrap a Spring application.&nbsp;</li>
                        </ul>
                     </li>
                     <li ><strong >Application events and listeners </strong>
                        <ul >
                           <li >It allows us to create factories file in the META-INF folder like&nbsp;META-INF/spring.factories that is useful for adding listeners.</li>
                        </ul>
                     </li>
                     <li ><strong >Admin features </strong>
                        <ul >
                           <li >It accesses &amp; manages applications remotely by using spring.application.admin.enabled property.</li>
                        </ul>
                     </li>
                     <li ><strong >Externalized Configuration </strong>
                        <ul >
                           <li >It allows us to work with the same application in different environments</li>
                        </ul>
                     </li>
                     <li ><strong >YAML Support</strong>
                        <ul >
                           <li >It is a superset of JSON that externalizes configuration.</li>
                        </ul>
                     </li>
                     <li ><strong >Type-safe Configuration</strong>
                        <ul >
                           <li >It governs and validates the configuration of the application.</li>
                        </ul>
                     </li>
                     <li ><strong >Actuator</strong>
                        <ul >
                           <li >Spring boot Actuator helps us monitor and manage application when pushed to production.</li>
                        </ul>
                     </li>
                  </ol>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="4">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>How to create a Spring boot project?</span>
               </AccordionHeader>
               <AccordionBody accordionId="4">
                  <p className="text-align-justify is-style-default has-text-color" style={{color: '#647f19'}} ><strong ><em >Visit the Spring Initializer <a href="https://start.spring.io/">web page</a>&nbsp;and choose your Build, Spring Boot Version, platform, provide a Group, Artifact, and required dependencies, as shown below – </em></strong></p>
                  <Table bordered striped>
                     <thead >
                        <tr >
                           <th className="text-align-center">Topic</th>
                           <th className="text-align-center">Definition</th>
                        </tr>
                     </thead>
                     <tbody >
                        <tr >
                           <td className="text-align-left">Project</td>
                           <td className="text-align-left">It defines the&nbsp;kind&nbsp;of project i.e. Maven Project&nbsp;or&nbsp;Gradle Project. </td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Language</td>
                           <td className="text-align-left">It provides the choice among three languages&nbsp;Java, Kotlin,&nbsp;and&nbsp;Groovy. Java is by default selected.</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Spring Boot</td>
                           <td className="text-align-left">We can select the Spring Boot version. The latest version is 2.2.2.</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Group</td>
                           <td className="text-align-left">It denotes the&nbsp;package&nbsp;name. The default Group name is&nbsp;com.example</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Artifact</td>
                           <td className="text-align-left">It denotes the Application name. The default Artifact name is a demo.</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Name</td>
                           <td className="text-align-left">It is the same as&nbsp;Artifact.</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Description</td>
                           <td className="text-align-left">In the description field, we can write a&nbsp;description&nbsp;of the project.</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Package Name</td>
                           <td className="text-align-left">It is also similar to the&nbsp;Group&nbsp;name.</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Packaging</td>
                           <td className="text-align-left">We can select the&nbsp;packing&nbsp;of the project i.e. Jar&nbsp;or&nbsp;War.</td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Java</td>
                           <td className="text-align-left">We can select the&nbsp;JVM&nbsp;version which we want to use. </td>
                        </tr>
                        <tr >
                           <td className="text-align-left">Dependencies</td>
                           <td className="text-align-left">Dependencies are the collection of artifacts that we can add to our project.</td>
                        </tr>
                     </tbody>
                  </Table>
                  <br/>
                  <p className="text-align-justify" >Click on the Generate Project&nbsp;button, a zip file will download. After you download the project, unzip the file.&nbsp;</p>
                  <figure className="aligncenter size-full is-style-default" >
                     <img decoding="async" width="1200" height="643" src={springboot1} alt="" className="lazy-loaded" sizes="(max-width: 1200px) 100vw, 1200px" />
                  </figure>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="5">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Commonly used Spring Boot Annotations</span>
               </AccordionHeader>
               <AccordionBody accordionId="5">
                  <ol className="text-align-justify" >
                     <li ><strong >@SpringBootApplication </strong>
                        <ul >
                           <li >It is a combination of three annotations @ComponentScan, @EnableAutoConfiguration, and&nbsp;@Configuration.</li>
                        </ul>
                     </li>
                     <li ><strong >@Required</strong>
                        <ul >
                           <li >It applies to the&nbsp;bean&nbsp;setter method. </li>
                           <li >It indicates that the beans with annotation must populate at configuration time with the required property, else it throws an exception BeanInitilizationException.</li>
                        </ul>
                     </li>
                     <li ><strong >@Configuration</strong>
                        <ul >
                           <li >It is a class-level annotation. </li>
                           <li >It generates bean definitions and service requests.</li>
                        </ul>
                     </li>
                     <li ><strong >@EnableAutoConfiguration</strong> &nbsp;
                        <ul >
                           <li >It auto-configures the bean that is present in the classpath and configures it to run the methods.</li>
                        </ul>
                     </li>
                     <li ><strong >@Component</strong>
                        <ul >
                           <li >It is a class-level annotation. </li>
                           <li >It marks Java class as a bean. </li>
                           <li >A Java class with&nbsp;@Component&nbsp;annotation is looked for in the classpath.</li>
                           <li >If a class is found, the Spring Framework will configure it in the application context as a&nbsp;Spring Bean.</li>
                        </ul>
                     </li>
                     <li ><strong >@ComponentScan</strong>
                        <ul >
                           <li >It scans a package for beans.</li>
                           <li >One can use this annotation along with the @Configuration annotation. </li>
                        </ul>
                     </li>
                     <li ><strong >@Autowired</strong>
                        <ul >
                           <li >It auto wires spring bean on setter methods, instance variable, and constructor. </li>
                           <li >In other words, it allows automatic dependency injection. The spring container injects the dependent beans by matching data-type.</li>
                        </ul>
                     </li>
                     <li ><strong >@Controller</strong>
                        <ul >
                           <li >The @Controller is a class-level annotation. </li>
                           <li >It marks the Java class as a web request handler.</li>
                           <li >By default, it returns a string that tells the route to redirect.</li>
                        </ul>
                     </li>
                  </ol>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="6">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Some other annotations</span>
               </AccordionHeader>
               <AccordionBody accordionId="6">
                  <ol className="text-align-justify" >
                     <li ><strong >@Bean</strong>
                        <ul >
                           <li >The @Bean is a method-level annotation.</li>
                           <li >It act as an alternative of XML {'<bean>'} tag.</li>
                           <li >This annotation tells the method to produce a bean that a Spring Container can manage.</li>
                        </ul>
                     </li>
                     <li ><strong >@Service</strong>
                        <ul >
                           <li >It is a class-level annotation.</li>
                           <li >It tells the Spring that class contains business logic.</li>
                        </ul>
                     </li>
                     <li ><strong >@Repository</strong>
                        <ul >
                           <li >It is a class-level annotation.</li>
                           <li >The repository is a&nbsp;DAO(Data Access Object) that access the database directly and perform all the operations related to the database.</li>
                        </ul>
                     </li>
                     <li ><strong >@RequestMapping</strong>
                        <ul >
                           <li >It helps to map the web requests.</li>
                           <li >It consists of optional elements. For Instance&nbsp;consumes, header, method, name, params, path, produce, and&nbsp;value.</li>
                        </ul>
                     </li>
                     <li ><strong >@GetMapping</strong>
                        <ul >
                           <li >It maps the&nbsp;HTTP GET&nbsp;requests on the specific handler method.</li>
                        </ul>
                     </li>
                     <li ><strong >@PostMapping</strong>
                        <ul >
                           <li >It maps the&nbsp;HTTP POSTrequests on the specific handler method.</li>
                        </ul>
                     </li>
                     <li ><strong >@PutMapping</strong>
                        <ul >
                           <li >&nbsp;It maps the&nbsp;HTTP PUT&nbsp;requests on the specific handler method.</li>
                        </ul>
                     </li>
                     <li ><strong >@DeleteMapping</strong>
                        <ul >
                           <li >It maps the&nbsp;HTTP DELETE&nbsp;requests on the specific handler method.</li>
                        </ul>
                     </li>
                     <li ><strong >@PatchMapping</strong>
                        <ul >
                           <li >It maps the&nbsp;HTTP PATCH&nbsp;requests on the specific handler method.</li>
                        </ul>
                     </li>
                     <li ><strong >@RequestBody</strong>
                        <ul >
                           <li >It binds&nbsp;HTTP request with an object in a method parameter.</li>
                        </ul>
                     </li>
                     <li ><strong >@ResponseBody</strong>
                        <ul >
                           <li >It binds the method return value to the response body.</li>
                        </ul>
                     </li>
                     <li ><strong >@PathVariable</strong>
                        <ul >
                           <li >It extracts the values from the URI.</li>
                        </ul>
                     </li>
                     <li ><strong >@RequestParam</strong>
                        <ul >
                           <li >It extracts the query parameters from the URL.</li>
                        </ul>
                     </li>
                     <li ><strong >@RequestHeader</strong>
                        <ul >
                           <li >It helps us get the details about the HTTP request headers.</li>
                        </ul>
                     </li>
                     <li ><strong >@RestController</strong>
                        <ul >
                           <li >It is a combination of @Controller and @ResponseBody annotations</li>
                        </ul>
                     </li>
                  </ol>
                  <br/>
                  <figure className="aligncenter size-large is-style-default" >
                     <img decoding="async" width="568" height="327" src={springboot2} alt="" className="lazy-loaded" sizes="(max-width: 568px) 100vw, 568px" />
                  </figure>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="7">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>How does it work ?</span>
               </AccordionHeader>
               <AccordionBody accordionId="7">
                  <ul className="text-align-justify" >
                     <li >@EnableAutoConfiguration annotation allows Spring Boot to automatically configure your application based on the dependencies you have added to the project.</li>
                     <li >The class that contains @SpringBootApplication annotation is the entry point of the spring boot application.</li>
                     <li >To run the Spring Boot application, this class should have the main method.</li>
                     <li >@SpringBootApplication&nbsp;annotation includes Auto- Configuration, Component Scan, and Spring Boot Configuration.</li>
                     <li >SpringApplication.run() inside the main method will bootstrap String application as a stand-alone application.</li>
                     <li >It creates an instance of ApplicationContext and loads all the beans.</li>
                     <li >It then runs the embedded Server.</li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="8">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Beans</span>
               </AccordionHeader>
               <AccordionBody accordionId="8">
                  <ul className="text-align-justify" >
                     <li >Bean is an object and is managed by the Spring IoC container.</li>
                     <li >It also forms the backbone of your application.</li>
                     <li >Spring IoC container instantiates, assembles, and otherwise manages bean.</li>
                     <li >Creation of beans is done with the help of configuration metadata that we supply to the container.</li>
                     <li ><strong>Bean Scopes :</strong>
                        <ol >
                           <li ><strong >singleton</strong>
                              <ul >
                                 <li >This limits the scope of a bean definition to a single instance per Spring IoC container (default).</li>
                              </ul>
                           </li>
                           <li ><strong >prototype</strong>&nbsp;
                              <ul >
                                 <li >This limits the scope of a single bean definition to have any number of object instances.</li>
                              </ul>
                           </li>
                           <li ><strong >request</strong>&nbsp;
                              <ul >
                                 <li >This limits the scope of a bean definition to an HTTP request.</li>
                              </ul>
                           </li>
                           <li ><strong >session</strong>&nbsp;
                              <ul >
                                 <li >This limits the scope of a bean definition to an HTTP session.</li>
                              </ul>
                           </li>
                           <li ><strong >global-session</strong>&nbsp;
                              <ul >
                                 <li >This limits the scope of a bean definition to a global HTTP session.</li>
                              </ul>
                           </li>
                        </ol>
                     </li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="9">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Dependency Injection</span>
               </AccordionHeader>
               <AccordionBody accordionId="9">
                  <ul className="text-align-justify" >
                     <li >It&nbsp;is a technique whereby one object (or static method) supplies the&nbsp;dependencies&nbsp;of another object.</li>
                     <li >It is a design pattern that helps us implement IoC.</li>
                     <li >Dependency Injection is responsible for the creation of dependent objects outside of a class. It also provides those objects to a class in different ways.</li>
                     <li >It helps to move the creation and binding of the dependent objects outside of the class that depends on them.</li>
                     <li ><strong>Types of DI :</strong>
                        <ol >
                           <li ><strong >Constructor-based</strong>
                              <ul >
                                 <li >It is achieved when the class constructor is invoked by the spring container along with some arguments, where each argument is representing a dependency on the other class.</li>
                              </ul>
                           </li>
                           <li ><strong >Setter-based</strong>
                              <ul >
                                 <li >It is achieved when after invoking a no-argument constructor or no-argument static factory method, then spring container calls the setter methods on the bean to instantiate the bean.</li>
                              </ul>
                           </li>
                        </ol>
                     </li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="10">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>IOC Containers</span>
               </AccordionHeader>
               <AccordionBody accordionId="10">
                  <ul className="text-align-justify" >
                     <li >The Spring creates the objects, wire them together, configure them, and manage their complete life cycle from creation till destruction.</li>
                     <li >The container gets its instructions with the help of the configuration metadata provided, about what objects to instantiate, configure, and assemble.</li>
                     <li >It makes use of Java POJO classes and configuration metadata to produce a fully configured and executable system or application.</li>
                     <li ><strong>Types of a container :</strong>
                        <ol >
                           <li ><strong >BeanFactory </strong>
                              <ul >
                                 <li >This container provides the basic support for DI and is defined by the  interface: </li>
                                 <SyntaxHighlighter language="" style={dracula} customStyle={{ background: 'grey'}} showLineNumbers={false}>
                                    {'org.springframework.beans.factory.BeanFactory'}
                                 </SyntaxHighlighter>
                              </ul>
                           </li>
                           <li ><strong >ApplicationContext </strong>
                              <ul >
                                 <li >It adds more enterprise-specific functionality. For instance, it resolves textual messages from a properties file and publishes the application events to interested event listeners.</li>
                                 <li >This container is defined by the interface: </li>
                                 <SyntaxHighlighter language="" style={dracula} customStyle={{ background: 'grey'}} showLineNumbers={false}>
                                    {'org.springframework.context.ApplicationContext'}
                                 </SyntaxHighlighter>
                              </ul>
                           </li>
                        </ol>
                     </li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="11">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>CORS Support</span>
               </AccordionHeader>
               <AccordionBody accordionId="11">
                  <p className="text-align-justify" >Security that restricts the resources implemented in web browsers is known as Cross-Origin Resource Sharing (CORS). If your web application is running on 8080 port and by using JavaScript you are trying to consume RESTful web services from 9090 port. In such a case, you will face the Cross-Origin Resource Sharing security issue on your web browsers. By using @CrossOrigin annotation on the controller method, we can set the origins for the RESTful web service. This annotation supports specific REST API, and not for the entire application.</p>
                  <p className="text-align-justify" >There are two pre-requisites to handle this issue :</p>
                  <ul className="text-align-justify" >
                     <li >RESTful web services should support Cross-Origin Resource Sharing.</li>
                     <li >RESTful web service applications should allow accessing the API(s) from the 8080 port.</li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="12">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Spring Boot Actuator</span>
               </AccordionHeader>
               <AccordionBody accordionId="12">
                  <p className="text-align-justify" >To help us monitor and manage a Spring Boot application, the Spring Boot Actuator provides secured endpoints. By default, all actuator endpoints are secure. It helps monitor and manage application when pushed to production. To enable the Spring Boot actuator endpoints in a Spring Boot application, one needs to add the Spring Boot Starter actuator dependency (spring-boot-starter-actuator) in the build configuration file.</p>
                  <p className="text-align-justify" >The&nbsp;<strong >three</strong>&nbsp;main features of Spring Boot Actuator are:</p>
                  <ul className="text-align-justify" >
                     <li ><strong >Endpoints :</strong> &nbsp;It allows one to monitor and interact with the application. Spring Boot also provides a number of built-in endpoints. Some endpoints and their usage –
                        <ul >
                           <li ><strong >/metrics</strong> endpoint is used to view the application metrics. For instance, memory used, memory-free, threads, classes, system uptime, etc.</li>
                           <li ><strong >/env</strong> endpoint is used to view the list of Environment variables used in the application.</li>
                           <li ><strong >/beans</strong> endpoint is used to view the Spring beans and its types, scopes, and dependency.</li>
                           <li ><strong >/health</strong> endpoint is used to view the application health</li>
                           <li ><strong >/info</strong> endpoint is used to view the information about the Spring Boot application.</li>
                           <li ><strong >/trace</strong> endpoint is used to view the list of Traces of your Rest endpoints.</li>
                        </ul>
                     </li>
                     <br/>
                     <li ><strong >Metrics :</strong> Spring Boot Actuator provides dimensional metrics by integrating with the micrometer. The micrometer is integrated into Spring Boot. It provides vendor-neutral interfaces for timers, gauges, counters, distribution summaries, and long task timers with a dimensional data model.</li>
                     <br/>
                     <li ><strong >Audit :</strong> A flexible audit framework that publishes events to an AuditEventRepository is provided by Spring Boot<strong >.</strong>&nbsp;It automatically publishes the authentication events if spring-security is in execution.</li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="13">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Spring Boot DevTools</span>
               </AccordionHeader>
               <AccordionBody accordionId="13">
                  <p className="text-align-justify" >DevTools i.e., Developer Tool aims to try and improve the development time of the Spring Boot application. Spring Boot DevTools picks up any change made and restarts the application. The DevTools always monitor classpath resources. The only way to trigger a restart is to update the classpath. Spring Boot DevTools provides the following features :</p>
                  <ul className="text-align-justify" >
                     <li ><strong >Property Defaults</strong>
                        <ul>
                           <li>It will disable the caching and allow us to update the pages without restarting the application. But setting up these properties while development always creates some problems.</li>
                        </ul>
                     </li>
                     <li ><strong >Automatic Restart</strong>
                        <ul>
                           <li>It allows us to reload the Java classes and its configuration at the server-side. It is deployed dynamically after the server-side changes are made, then, the server restarts, and loads the modified code. It is mostly used in microservice-based applications.</li>
                        </ul>
                     </li>
                     <li ><strong >LiveReload</strong>
                        <ul>
                           <li>It is an embedded server that comes with the Spring Boot DevTools module. It allows an automatic trigger of a browser refresh by the application whenever any changes are made in the resources. We can disable this setting.</li>
                        </ul>
                     </li>
                     <li ><strong >Remote Debug Tunneling</strong>
                        <ul>
                           <li>It supports Spring Boot to tunnel JDWP (Java Debug Wire Protocol) over HTTP directly to the application.</li>
                        </ul>
                     </li>
                     <li ><strong >Remote Update and Restart</strong>
                        <ul>
                           <li>It supports remote application updates and restarts. It monitors the local classpath for file changes and pushes them to a remote server, which is then restarted.&nbsp;</li>
                        </ul>
                     </li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="14">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Advantages of Spring Boot</span>
               </AccordionHeader>
               <AccordionBody accordionId="14">
                  <ul className="text-align-justify" >
                     <li >Easy to understand.</li>
                     <li >Increases productivity</li>
                     <li >Reduces the cost and development time</li>
                     <li >Flexible enough to configure everything automatically. For instance, Java Beans, XML configurations, and Database Transactions.</li>
                     <li >Auto configured is available for everything; no need for manual configurations.</li>
                     <li >Offers annotation-based spring application</li>
                     <li >Includes Embedded Servlet Container</li>
                     <li >Production-ready&nbsp;features are available. For instance&nbsp;metrics, health checks,&nbsp;and&nbsp;externalized configuration.</li>
                     <li >Reduces or minimizes the writing of boilerplate codes. Here boilerplate codes mean the code that has to be written in many places within our program with little or no alteration.</li>
                  </ul>
               </AccordionBody>
            </AccordionItem>
            <AccordionItem>
               <AccordionHeader targetId="15">
                  <span className="fa fa-book"></span>
                  <span style={{marginLeft: '3vw'}}>Spring Boot example</span>
               </AccordionHeader>
               <AccordionBody accordionId="15">
                  <figure className="aligncenter size-large" >
                     <img decoding="async" width="1024" height="491" src={springboot3} alt="" className="lazy-loaded" sizes="(max-width: 1024px) 100vw, 1024px" />
                  </figure>
                  <br/>
                  <ul className="text-align-justify" >
                     <li >Go to <a href="https://start.spring.io/" target="_blank" rel="noreferrer noopener" >Spring Initializer</a></li>
                     <li >Select Project as Maven Project</li>
                     <li >Select Language as Java</li>
                     <li >Select Spring Boot with the latest version (not the SNAPSHOT version)</li>
                     <li >Enter details in Project Metadata
                        <ul >
                           <li >Group :  Enter package name</li>
                           <li >Artifact : Enter the project name</li>
                           <li >Name : Enter the project name</li>
                        </ul>
                     </li>
                     <li >Add dependencies
                        <ul >
                           <li >Web</li>
                           <li >DevTools</li>
                        </ul>
                     </li>
                     <li >Generate project</li>
                     <li >Extract the zip file and import the project in IDE</li>
                  </ul>
                  <br/>
                  <p className="text-align-center" style={{ fontSize: '20px' }} ><span className="has-inline-color has-secondary-color" ><strong ><em >pom.xml</em></strong></span></p>
                  <SyntaxHighlighter language="xml" style={dracula} showLineNumbers={true}>
                     {
                        '<?xml version="1.0" encoding="UTF-8"?>\n'+
                        '<project\n'+
                        '	xmlns="http://maven.apache.org/POM/4.0.0"\n'+
                        '	xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\n'+
                        '    xsi:schemaLocation="http://maven.apache.org/POM/4.0.0 https://maven.apache.org/xsd/maven-4.0.0.xsd">\n'+
                        '	<modelVersion>4.0.0</modelVersion>\n'+
                        '	<parent>\n'+
                        '		<groupId>org.springframework.boot</groupId>\n'+
                        '		<artifactId>spring-boot-starter-parent</artifactId>\n'+
                        '		<version>2.4.2</version>\n'+
                        '		<relativePath/>\n'+
                        '		<!-- lookup parent from repository -->\n'+
                        '	</parent>\n'+
                        '	<groupId>com.misstechack</groupId>\n'+
                        '	<artifactId>spring-boot-demo</artifactId>\n'+
                        '	<version>0.0.1-SNAPSHOT</version>\n'+
                        '	<name>spring-boot-demo</name>\n'+
                        '	<description>Demo project for Spring Boot</description>\n'+
                        '	<properties>\n'+
                        '		<java.version>1.8</java.version>\n'+
                        '	</properties>\n'+
                        '	<dependencies>\n'+
                        '		<dependency>\n'+
                        '			<groupId>org.springframework.boot</groupId>\n'+
                        '			<artifactId>spring-boot-starter-web</artifactId>\n'+
                        '		</dependency>\n'+
                        '		<dependency>\n'+
                        '			<groupId>org.springframework.boot</groupId>\n'+
                        '			<artifactId>spring-boot-devtools</artifactId>\n'+
                        '			<scope>runtime</scope>\n'+
                        '			<optional>true</optional>\n'+
                        '		</dependency>\n'+
                        '		<dependency>\n'+
                        '			<groupId>org.springframework.boot</groupId>\n'+
                        '			<artifactId>spring-boot-starter-test</artifactId>\n'+
                        '			<scope>test</scope>\n'+
                        '		</dependency>\n'+
                        '	</dependencies>\n'+
                        '	<build>\n'+
                        '		<plugins>\n'+
                        '			<plugin>\n'+
                        '				<groupId>org.springframework.boot</groupId>\n'+
                        '				<artifactId>spring-boot-maven-plugin</artifactId>\n'+
                        '			</plugin>\n'+
                        '		</plugins>\n'+
                        '	</build>\n'+
                        '</project>'
                     }
                  </SyntaxHighlighter>
                  <br/>
                  <br/>
                  <p className="text-align-center" style={{ fontSize: '20px' }}><span className="has-inline-color has-secondary-color" ><strong ><em >Student.java</em></strong></span></p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'package com.misstechack.demo;\n'+
                        '\n'+
                        'public class Student {\n'+
                        '  private String rollNo;\n'+
                        '  private String name;\n'+
                        '\n'+
                        '  public String getRollNo() {\n'+
                        '    return rollNo;\n'+
                        '  }\n'+
                        '  public void setRollNo(String rollNo) {\n'+
                        '    this.rollNo = rollNo;\n'+
                        '  }\n'+
                        '  public String getName() {\n'+
                        '    return name;\n'+
                        '  }\n'+
                        '  public void setName(String name) {\n'+
                        '    this.name = name;\n'+
                        '  }\n'+
                        '}'
                     }
                  </SyntaxHighlighter>
                  <br/>
                  <br/>
                  <p className="text-align-center" style={{ fontSize: '20px' }}><span className="has-inline-color has-secondary-color" ><strong ><em >Controller Class – StudentController.java</em></strong></span></p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'package com.misstechack.demo;\n'+
                        '\n'+
                        'import java.util.HashMap;\n'+
                        'import java.util.Map;\n'+
                        '\n'+
                        'import org.springframework.http.HttpStatus;\n'+
                        'import org.springframework.http.ResponseEntity;\n'+
                        'import org.springframework.web.bind.annotation.DeleteMapping;\n'+
                        'import org.springframework.web.bind.annotation.GetMapping;\n'+
                        'import org.springframework.web.bind.annotation.PathVariable;\n'+
                        'import org.springframework.web.bind.annotation.PostMapping;\n'+
                        'import org.springframework.web.bind.annotation.PutMapping;\n'+
                        'import org.springframework.web.bind.annotation.RequestBody;\n'+
                        'import org.springframework.web.bind.annotation.RestController;\n'+
                        '\n'+
                        '@RestController\n'+
                        'public class StudentController {\n'+
                        '  private static Map<String, Student> repo = new HashMap <>();\n'+
                        '  static {\n'+
                        '    Student student1 = new Student();\n'+
                        '    student1.setRollNo("1");\n'+
                        '    student1.setName("Amar");\n'+
                        '    repo.put(student1.getRollNo(), student1);\n'+
                        '\n'+
                        '    Student student2 = new Student();\n'+
                        '    student2.setRollNo("2");\n'+
                        '    student2.setName("Dolly");\n'+
                        '    repo.put(student2.getRollNo(), student2);\n'+
                        '  }\n'+
                        '\n'+
                        '  @GetMapping("/Students")\n'+
                        '  public ResponseEntity <Object> getStudent() {\n'+
                        '    return new ResponseEntity <>(repo.values(), HttpStatus.OK);\n'+
                        '  }\n'+
                        '\n'+
                        '  @PostMapping("/Students")\n'+
                        '  public ResponseEntity <Object> createStudent(@RequestBody Student Student) {\n'+
                        '    repo.put(Student.getRollNo(), Student);\n'+
                        '    return new ResponseEntity <>("Student is created successfully", HttpStatus.CREATED);\n'+
                        '  }\n'+
                        '\n'+
                        '  @PutMapping("/Students/{id}")\n'+
                        '  public ResponseEntity <Object> updateStudent(@PathVariable("id") String id, @RequestBody Student Student) {\n'+
                        '    repo.remove(id);\n'+
                        '    Student.setRollNo(id);\n'+
                        '    repo.put(id, Student);\n'+
                        '    return new ResponseEntity <>("Student is updated successfully", HttpStatus.OK);\n'+
                        '  }\n'+
                        '\n'+
                        '  @DeleteMapping(value = "/Students/{id}")\n'+
                        '  public ResponseEntity <Object> deleteStudent(@PathVariable("id") String id) {\n'+
                        '    repo.remove(id);\n'+
                        '    return new ResponseEntity <>("Student is deleted successfully", HttpStatus.OK);\n'+
                        '  }\n'+
                        '\n'+
                        '}'
                     }
                  </SyntaxHighlighter>
                  <br/>
                  <br/>
                  <p className="text-align-center" style={{ fontSize: '20px' }}><span className="has-inline-color has-secondary-color" ><strong ><em >Application Class</em></strong></span></p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'import org.springframework.boot.SpringApplication;\n'+
                        'import org.springframework.boot.autoconfigure.SpringBootApplication;\n'+
                        '\n'+
                        '@SpringBootApplication\n'+
                        'public class Application {\n'+
                        '\n'+
                        '  public static void main(String[] args) {\n'+
                        '    SpringApplication.run(Application.class, args);\n'+
                        '  }\n'+
                        '\n'+
                        '}'
                     }
                  </SyntaxHighlighter>
                  <br/>
                  <br/>
                  <p className="text-align-center" style={{ fontSize: '20px' }}><span className="has-inline-color has-secondary-color" ><strong ><em >Output</em></strong></span></p>
                  <figure className="aligncenter size-large is-style-default" >
                     <img decoding="async" width="991" height="447" src={springboot4} alt="" className="lazy-loaded" sizes="auto, (max-width: 991px) 100vw, 991px" />
                     <figcaption><span className="has-inline-color has-primary-color" >GET call output</span></figcaption>
                  </figure>
                  <br/>
                  <figure className="aligncenter size-large is-style-default" >
                     <img decoding="async" width="986" height="452" src={springboot5} alt="" className="lazy-loaded" sizes="auto, (max-width: 986px) 100vw, 986px" />
                     <figcaption><span className="has-inline-color has-primary-color" >POST call output</span></figcaption>
                  </figure>
                  <br/>
                  <figure className="aligncenter size-large is-style-default" >
                     <img decoding="async" width="990" height="457" src={springboot6} alt="" className="lazy-loaded" sizes="auto, (max-width: 990px) 100vw, 990px" />
                     <figcaption><span className="has-inline-color has-primary-color" >PUT call output</span></figcaption>
                  </figure>
                  <br/>
                  <figure className="aligncenter size-large is-style-default" >
                     <img decoding="async" width="990" height="361" src={springboot7} alt="" className="lazy-loaded" sizes="auto, (max-width: 990px) 100vw, 990px" />
                     <figcaption><span className="has-inline-color has-primary-color" >DELETE call output</span></figcaption>
                  </figure>
               </AccordionBody>
            </AccordionItem>
         </Accordion>
      </SpringBootWrapper>
   );
}

export default SpringBoot;
